import { Route } from 'types/route.type';
import SiteOverview from 'views/order-feed/features/my-supply-plan/features/ofd-2.0/components/site-overview';

export const routes: Route[] = [
  {
    path: '/order-feed/supply-plan/order-free-delivery/:siteErpId/:globalSiteId/:sectionTab?',
    component: SiteOverview,
  },
];
